export const ROLES={
    vendor:"vendor",
    operation:"operation"
}